/** @format */

import { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import CustomImage from '../../../v2-components/Antd/Image';
import CustomCard from '../../../v2-components/Antd/Card';

import { handleStock } from '../handle/stock.handle';
import { handleMecanic } from '../handle/mecanic.handle';
import { handlePrice } from '../handle/price.handle';
import { handlePromotionPrice } from '../handle/promotion-price.handle';
import { handleLaboratory } from '../handle/laboratory.handle';
import { handleName } from '../handle/name.handle';
import { handleSince } from '../handle/since.handle';
import { handleTagIcon } from '../handle/tag-icon.handle';
import { handleOriginalImage } from '../handle/original-image.handle';
import { handleRecipeIcon } from '../handle/recipe-icon.handle';
import { image } from '../constant/image.constant';
import './style.scss';

import Button from '../../../components/Commons/Product/components/Button';
import { ModalTypeRecipes } from '../../../components/Commons/Modals/ModalTypeRecipes';
import { handlePharmacy } from '../handle/pharmacy.handle';
import { linkToDetailProduct } from '../../../components/Commons/Hooks/Functions/LinkToDetailProduct';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { cenabastIconHandle } from '../handle/cenabast-icon.handle';
import { Service } from './service';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

let cachedModules = null;
let cachedIconUrl = null;
let cachedPromise = null;

const fetchModulesOnce = () => {
	if (cachedModules) {
		return Promise.resolve(cachedModules);
	}

	if (cachedPromise) {
		return cachedPromise;
	}

	cachedPromise = new Service()
		.getModulesByTemplate('home', 'ecommerce', Enviroment.ROOT_PHARMACY)
		.then((res) => {
			const data = res?.data || [];
			cachedModules = Array.isArray(data) ? data : [];

			const pharmacyIcon = cachedModules.find((m) => m.location === 'icon-and-favicon');
			cachedIconUrl = pharmacyIcon?.image || null;

			return cachedModules;
		})
		.catch((err) => {
			console.error('Error cargando módulos:', err);
			cachedModules = [];
			cachedIconUrl = null;
			return cachedModules;
		});

	return cachedPromise;
};

export default function CardProductDesktop(props) {
	const { product } = props;
	const [imageSrc, setImageSrc] = useState(product.original_image);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const history = useHistory();

	//eslint-disable-next-line
	const [modules, setModules] = useState(cachedModules || []);
	const [loadingModules, setLoadingModules] = useState(!cachedModules);
	const [iconUrl, setIconUrl] = useState(cachedIconUrl || null);

	const handleTypeRecipes = () => {
		setIsModalOpen(true);
	};

	const handleOk = () => {
		setIsModalOpen(false);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	useEffect(() => {
		setImageSrc(product.original_image);
	}, [product.original_image]);

	const handleImageError = () => {
		setImageSrc(image.default);
	};

	const handleStopPropagation = (event) => {
		event.stopPropagation();
	};

	useEffect(() => {
		let mounted = true;

		if (cachedModules) {
			setModules(cachedModules);
			setIconUrl(cachedIconUrl || null);
			setLoadingModules(false);
			return () => {
				mounted = false;
			};
		}

		fetchModulesOnce().then((mods) => {
			if (!mounted) return;
			setModules(mods);
			const pharmacyIcon = mods.find((m) => m.location === 'icon-and-favicon');
			const icon = pharmacyIcon?.image || cachedIconUrl || null;
			setIconUrl(icon);
			setLoadingModules(false);
		});

		return () => {
			mounted = false;
		};
	}, []);

	return (
		<>
			<CustomCard className="own-card-product-desktop" onClick={() => history.push(linkToDetailProduct(product))}>
				<Row gutter={4} className="own-image-icons-container">
					<Col span={4} className="own-card-icons-container" onClick={handleStopPropagation}>
						{handleTagIcon(product)}
						<div className="own-card-icons-sub-container" onClick={handleTypeRecipes}>
							{handleRecipeIcon(product)}
							{cenabastIconHandle(product)}
						</div>
						<ModalTypeRecipes isModalOpen={isModalOpen} handleOk={handleOk} handleCancel={handleCancel} />
					</Col>

					<Col span={16}>
						<Row gutter={16}>
							<CustomImage src={handleOriginalImage(imageSrc)} width={150} onError={handleImageError} />
						</Row>
					</Col>
				</Row>

				<Row justify="start">{handleLaboratory(product, 'own-laboratory-label')}</Row>

				<Row justify="center">{handleName(product, 'own-product-title')}</Row>

				{!loadingModules && iconUrl && <Row justify="start">{handlePharmacy(iconUrl, product, 'temporary-pharmacy-icon')}</Row>}

				<Row justify="start">{handleStock(product, 'own-stock')}</Row>

				<Row className="own-promotion-prices-container">
					<Row justify="start">{handleSince(product, 'own-since')}</Row>
					<Row justify="center">{handleMecanic(product, 'own-mecanic')}</Row>
					<Row className="own-price-container">
						{handlePromotionPrice(product, 'own-promotion-price')}
						{handlePrice(product, 'own-final-price')}
					</Row>
				</Row>

				<Row className="own-add-button-slot" justify="center" onClick={handleStopPropagation}>
					<Button available={product.available} detail={product} />
				</Row>
			</CustomCard>
		</>
	);
}
